
export function farloUiMasthead(element) {
    const siteCastUpper = element.querySelector('.masthead-slider__upper');
    const siteCastLower = element.querySelector('.masthead-slider__lower');


    flkty = new Flickity(siteCastUpper, {
        cellAlign: 'left',
        pageDots: true,
        prevNextButtons: true,
        scrollSnap: true,
        wrapAround: true,
        groupCells: false,
        freeScroll: false,
        draggable: false,
        fade: false,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 60, y2: 40,
            x3: 60
        }
    });

    flkty = new Flickity(siteCastLower, {
        cellAlign: 'center',
        asNavFor: siteCastUpper,
        pageDots: false,
        prevNextButtons: false,
        scrollSnap: true,
        wrapAround: false,
        groupCells: false,
        freeScroll: false,
        draggable: false,
        fade: true,
    });


}
